const selectRegFormData = (screens) => {
  try {
    return JSON.parse(screens.registrationForm);
  } catch (error) {
    return {};
  }
};

export default selectRegFormData;
